var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBestCategory = function SvgBestCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#best-category_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#best-category_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DB9F44",
    d: "m8.287 13.78.853-3.253a.5.5 0 0 1 .834-.234l3.333 3.24-2.5 2.24zM23.707 13.78l-.854-3.253a.5.5 0 0 0-.833-.234l-3.334 3.24 2.5 2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA82",
    d: "m26 22.627 1.7-12.447-6.807 3.907L16 6.427l-4.893 7.66L4.3 10.18l1.706 12.447a24.37 24.37 0 0 0 20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8952",
    d: "M16 21.633a2.253 2.253 0 1 0 0-4.506 2.253 2.253 0 0 0 0 4.506"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCC963",
    d: "M4.3 11.527a1.353 1.353 0 1 0 0-2.707 1.353 1.353 0 0 0 0 2.707M27.7 11.533a1.347 1.347 0 1 0 0-2.693 1.347 1.347 0 0 0 0 2.693M16 7.78a1.353 1.353 0 1 0 0-2.707 1.353 1.353 0 0 0 0 2.707M25.706 24.893a24.37 24.37 0 0 1-19.453 0 .45.45 0 0 1-.267-.42v-1.846a24.37 24.37 0 0 0 20 0v1.846a.46.46 0 0 1-.28.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E6E",
    d: "M9.247 19.833a1.353 1.353 0 1 0 0-2.706 1.353 1.353 0 0 0 0 2.706M22.754 19.833a1.353 1.353 0 1 0 0-2.706 1.353 1.353 0 0 0 0 2.706"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "best-category_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "best-category_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgBestCategory;